import { ChangeDetectorRef, Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TemplatesService } from '../../../../services/templates.service';
import { DxButtonModule, DxDataGridModule, DxToastModule } from 'devextreme-angular';
import { AppGlobals } from '../../../../app.globals';
import { DeletePopupComponent } from '../../../../components/delete-popup/delete-popup.component';
import { environment } from '../../../../../environments/environment';
import { SectionAreaTypesComponent } from "./sections/area-types/area-types.component";
import { SectionRemunerationTagsComponent } from "./sections/remuneration-tags/remuneration-tags.component";

@Component({
    selector: 'app-config-project-params',
    imports: [CommonModule, SectionAreaTypesComponent, SectionRemunerationTagsComponent],
    templateUrl: './config-project-params.page.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./config-project-params.page.css']
})
export class ConfigProjectParamsPageComponent implements OnInit {


  constructor(
  
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
  }
}
